import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { eventLogger } from 'services/eventLogger.service'

import { AppLinks } from 'root-constants'

type TProps = {
  title?: string
}

export const PrivacyPolicyLink: React.FC<TProps> = ({
  title = 'commonComponents.privacyPolicy',
}) => {
  const { t } = useTranslation()

  return (
    <Link
      to={AppLinks.PP_LINK}
      onClick={() => eventLogger.logPrivacyPolicyClicked()}
      target="_blank"
      rel="noopener noreferrer"
    >
      {t(title)}
    </Link>
  )
}
